import { CART_MODULE } from "@/api_framework/api_config";
import axios from "axios";
import { useCallback } from "react";
import { useConfiguration } from "../../useConfiguration";

export const useSendBookingMirrorEventAPI = () => {
  const configuration = useConfiguration();

  const execute = useCallback(
    async (eventType: string, payload?: any) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const endpoint = CART_MODULE?.CM_BOOKING_MIRROR?.baseURL ?? "";

        await axios.post(
          endpoint,
          {
            event_type: eventType,
            payload: payload ?? {},
            ts: Date.now(),
          },
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
      } catch (e: any) {
        console.error("[MirrorEvent] failed to send:", eventType, e);
      }
    },
    [configuration],
  );

  return { execute };
};
